import React from 'react';
import { Box, Card, CardContent, Typography } from '@mui/material';
import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward';
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';
import { usePortalTokens } from '../../../styles/usePortalTokens';
import { getPortalCardSx } from '../../../styles/portalSurfaces';

const PartnerStatCard = ({
  title,
  value,
  trend,
  trendUp,
  subtitle,
  icon: Icon,
  iconBg,
  iconColor,
}) => {
  const portal = usePortalTokens();
  const hasValue = value !== null && value !== undefined && value !== '';

  return (
    <Card elevation={0} sx={getPortalCardSx(portal, { borderRadius: '12px', height: '100%' })}>
      <CardContent
        sx={{ p: 2, height: '100%', boxSizing: 'border-box', '&:last-child': { pb: 2 } }}
      >
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            gap: 1.25,
            mb: 1.5,
          }}
        >
          <Box
            sx={{
              width: 40,
              height: 40,
              borderRadius: '8px',
              bgcolor: iconBg,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              flexShrink: 0,
            }}
          >
            <Icon sx={{ fontSize: 22, color: iconColor }} />
          </Box>
          <Typography
            sx={{
              color: 'text.secondary',
              fontWeight: 500,
              fontSize: '0.8125rem',
              lineHeight: 1.3,
              m: 0,
            }}
          >
            {title}
          </Typography>
        </Box>

        <Box sx={{ display: 'flex', alignItems: 'center', flexWrap: 'wrap', gap: 0.75, mb: 0.75 }}>
          <Typography
            component="span"
            sx={{
              fontSize: '1.625rem',
              fontWeight: 700,
              color: hasValue ? 'text.primary' : 'text.disabled',
              lineHeight: 1.1,
              minHeight: '1.8rem',
            }}
          >
            {hasValue ? value : '—'}
          </Typography>
          {trend != null ? (
            <Box
              sx={{
                display: 'inline-flex',
                alignItems: 'center',
                gap: 0.25,
                px: 0.75,
                py: 0.25,
                borderRadius: '12px',
                bgcolor: trendUp ? 'success.light' : 'error.light',
                color: trendUp ? 'success.dark' : 'error.dark',
                fontSize: '0.75rem',
                fontWeight: 600,
                lineHeight: 1,
              }}
            >
              {trendUp ? (
                <ArrowUpwardIcon sx={{ fontSize: 12 }} />
              ) : (
                <ArrowDownwardIcon sx={{ fontSize: 12 }} />
              )}
              {trend}%
            </Box>
          ) : null}
        </Box>

        <Typography sx={{ color: 'text.secondary', fontSize: '0.6875rem', lineHeight: 1.35 }}>
          {subtitle}
        </Typography>
      </CardContent>
    </Card>
  );
};

export default PartnerStatCard;
